import React, { useState, useCallback, useMemo, useEffect, useRef } from "react";
import Button from "../../../button/button";
import CleanSVG from "../../../icons/clean";
import ThunderSVG from "../../../icons/thunder";
import InputAnimated from "../../../inputAnimated/inputAnimated";
import Select from "../../../select/select";
import "./PaymentReceipt.scss";
import StudentSection from "./StudentSection/StudentSection";
import { useNavigate } from "react-router-dom";
import Axios from 'axios'
import PaymentConfirm from "./PaymentConfirm/paymentConfirm";
import Alert from "../../../alert/Alert";
import { PostPromotionCodeClass, GetCurrency, GetLevelListV2, GetPaymentConcepts, GetStudentListBySubsidiary } from "../../../../utils/Apis/apis";
import Tooltip from "../../../Tooltip/Tooltip";
import SelectSubsidiary from "./SelectSubsidiary/SelectSubsidiary";
import { getLocalDateObjectFromInput } from "../../../../utils/dateTimeZone";
import { isWeekInRanges } from "../../../../utils/receptionUtils/payment";
import { getWeekRange } from "../../../../utils/dateUtils";
const PaymentReceipt = ({ listSubsidiary, usr, specialDateList, exemptWeeks, levelUnitList, paymentStudentData, setPaymentStudentData }) => {
    const [subsidiaryList, setSubsidiaryList] = useState([])
    const [levelList, setLevelList] = useState([])
    const [studentsList, setStudentsList] = useState([]);
    const [specialDates, setSpecialDates] = useState([])
    const [exchange, setExchange] = useState('')
    const [disableConfirmButton, setDisableConfirmButton] = useState(false)
    ////Alert
    const [isVisibleAlert, setIsVisibleAlert] = useState(false);
    const [arrayAlerts, setArrayAlerts] = useState([])
    //
    const [selectedSubsidiary, setSelectedSubsidiary] = useState('')
    //
    const [isOpenConfirm, setIsOpenConfirm] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    //Promotion code
    const [promoCode, setPromoCode] = useState('')
    const [lastPromoCode, setLastPromoCode] = useState('');

    // State to manage the list of students in the receipt
    const [students, setStudents] = useState([
        {
            id_student_section: Date.now(),
            id_student: "",
            name: "",
            concepts_to_pay: {
                tuition: [],
                books: [],
                inscription: {}
            },
            id_class: '',
            inscription_date: '',
            paymentHistory: [],
            schoolarship: {}
        }
    ]);

    const selectedStudentIds = students
        .map(s => s.id_student)
        .filter(Boolean);


    const [amountInscription, setAmountInscription] = useState('')

    //
    const [openModalSubsidiaryReceipts, setOpenModalSubsidiaryReceipts] = useState(false)

    const cacheStudents = useRef({}); // 🔄 Caché por plantel
    useEffect(() => {
        const controller = new AbortController();
        const daysOrder = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

        function compressDays(days) {
            const indices = days.map(d => daysOrder.indexOf(d)).sort((a, b) => a - b);
            let result = [];
            let temp = [indices[0]];

            for (let i = 1; i < indices.length; i++) {
                if (indices[i] === indices[i - 1] + 1) {
                    temp.push(indices[i]);
                } else {
                    if (temp.length > 1) {
                        result.push(`${daysOrder[temp[0]]}-${daysOrder[temp[temp.length - 1]]}`);
                    } else {
                        result.push(daysOrder[temp[0]]);
                    }
                    temp = [indices[i]];
                }
            }

            if (temp.length > 1) {
                result.push(`${daysOrder[temp[0]]}-${daysOrder[temp[temp.length - 1]]}`);
            } else {
                result.push(daysOrder[temp[0]]);
            }

            return result.join(", ");
        }

        function formatTime(time24) {
            let [h, m] = time24.split(":").map(Number);
            const ampm = h >= 12 ? "PM" : "AM";
            h = h % 12 || 12;
            return `${h}:${m.toString().padStart(2, "0")} ${ampm}`;
        }
        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                // 🔍 Revisamos si ya tenemos el resultado en caché
                if (cacheStudents.current[selectedSubsidiary]) {
                    const cachedData = cacheStudents.current[selectedSubsidiary];
                    setStudentsList(cachedData);
                    setSubsidiaryList(listSubsidiary);
                    setLoading(false);
                    return;
                }

                const studentListResponse = await GetStudentListBySubsidiary(selectedSubsidiary, 1);
                if (controller.signal.aborted) return;

                if (studentListResponse.auth === false) {
                    navigate("/login");
                    return;
                }
                const formattedList = studentListResponse.result.map((v) => ({
                    id: v.student.id,
                    name: `${v.student.name} ${v.student.middle_name} ${v.student.last_name}`,
                    class_info: {
                        id: v.class_info.id,
                        full_day_class_name: `${v.class_info?.teacher?.split(" ")?.slice(0, 2)?.join(" ") || 'Maestro no asignado'} ${v.class_info?.level?.name || ''} ${v.class_info?.level?.unit_name || ''} ${v.class_info?.day ? compressDays(v.class_info.day.split(",").map(d => d.trim())) : ''} ${v.class_info?.time_start ? formatTime(v.class_info.time_start) : ''} - ${v.class_info?.time_end ? formatTime(v.class_info.time_end) : ''}`,
                        is_online: v.class_info.is_online,
                        class_type: v.class_info?.class_type,
                        days: v.class_info?.day,
                        level: v.class_info?.level
                    },
                    inscription_date: v.student.inscription_date || '',
                    observation: v.student.observation || '',
                    have_to_pay_enroll: v.have_to_pay_enroll
                }));

                // 🧠 Guardar en caché
                cacheStudents.current[selectedSubsidiary] = formattedList;
                setStudentsList(formattedList);
            } catch (err) {
                if (!controller.signal.aborted) {
                    setError("Error al cargar los alumnos");
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        setSubsidiaryList(listSubsidiary);
        if (selectedSubsidiary) {
            fetchData();

        }

        return () => {
            controller.abort(); // Cancelar solicitud si cambia `selectedSubsidiary` o se desmonta
        };
    }, [selectedSubsidiary]);

    useEffect(() => {

        if (!paymentStudentData) return;

        setSelectedSubsidiary(paymentStudentData.subsidiary);

    }, [paymentStudentData]);

    useEffect(() => {
        const controller = new AbortController();
        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                // Ejecutar ambas peticiones en paralelo
                const [levelListResponse, paymentConceptsResponse, currencyResponse] = await Promise.all([
                    GetLevelListV2(),
                    GetPaymentConcepts(),
                    GetCurrency()
                ]);
                if (controller.signal.aborted) return;

                // Validar autenticación en ambas respuestas
                if (levelListResponse.auth === false || paymentConceptsResponse.auth === false || currencyResponse.auth === false) {
                    navigate("/login");
                    return;
                }

                // Formatear niveles
                const { adults, kids } = levelListResponse.result;
                const formattedLevels = [...adults, ...kids].map((level) => ({
                    value: String(level.id),
                    label: level.name,
                    price: level.book_price,
                    stock: level.stock
                }));

                paymentConceptsResponse.result.map((v) => {
                    if (v.name === 'Inscripcion') {
                        setAmountInscription(v.amount)
                    }
                })
                setLevelList(formattedLevels);
                currencyResponse.result.map((v) => {
                    if (v.name === 'USD') {
                        setExchange(v.exchange_rate)
                    }
                })

            } catch (err) {
                if (!controller.signal.aborted) {
                    setError("Error al cargar los datos");
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        fetchData();

        return () => {
            controller.abort();
        };
    }, []);

    useEffect(() => {
        const studentNotSelected = students.some((student) => student.id_student === '')
        if (selectedSubsidiary === '' || studentNotSelected || students.length === 0) {
            setDisableConfirmButton(true)
        } else {
            setDisableConfirmButton(false)
        }
    }, [selectedSubsidiary, students])

    useEffect(() => {
        if (!specialDateList) return;

        const weekRangeArray = []; // lo vamos a llenar para cada evento

        const rangeWeekNumbers = (start, end) => {
            let endMonth = end.getMonth();
            let endYear = end.getFullYear();
            let startWeek = getWeekNumber(start);
            let endWeek = getWeekNumber(new Date(endYear, endMonth, end.getDate() - 1));
            let startYear = startWeek.year;
            let daysBetween = (end - start) / (1000 * 60 * 60 * 24);

            weekRangeArray.length = 0;

            let i = startWeek.weekNumber;
            let year = startYear;

            while (true) {
                weekRangeArray.push({ week: i, year });

                if (i === endWeek.weekNumber && year === endYear) {
                    break;
                }

                i++;
                if (i > 52) {
                    i = 1;
                    year++;
                }
            }
        };
        //Function to get de week number of a date
        function getWeekNumber(date) {
            const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            // Ajustar para que la semana inicie en lunes
            tempDate.setUTCDate(tempDate.getUTCDate() + 4 - (tempDate.getUTCDay() || 7));
            // Calcular el inicio del año
            const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
            // Calcular la diferencia en días y obtener la semana
            const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);

            return { weekNumber, year: tempDate.getUTCFullYear() };
        }

        const specialWeeks = specialDateList.map(({ name, date_start, date_end }) => {
            const start = getLocalDateObjectFromInput(date_start.split('T')[0]); // solo fecha YYYY-MM-DD
            const end = getLocalDateObjectFromInput(date_end.split('T')[0]);
            rangeWeekNumbers(start, end);

            return {
                name,
                weeks: [...weekRangeArray] // copia para que no se sobrescriba
            };
        });
        setSpecialDates(specialWeeks)
    }, [specialDateList]);

    useEffect(() => {
        if (!localStorage.getItem('receptionSubsidiarySession')) {
            setOpenModalSubsidiaryReceipts(true)
        }
    }, [])

    const handleCloseModalToReceiptsSubsidiarySelect = () => {
        setOpenModalSubsidiaryReceipts(false)
    }

    const handleSubsidiarySelected = (value) => {
        setStudents([
            {
                id_student_section: Date.now(),
                id_student: "",
                name: "",
                concepts_to_pay: {
                    tuition: [],
                    books: [],
                    inscription: {}
                },
                id_class: '',
                inscription_date: '',
                paymentHistory: [],
                schoolarship: {}
            }
        ])
        setSelectedSubsidiary(value);
        setPromoCode('')
        setLastPromoCode('')

    }


    // Calculate the total amount for all students (tuition, inscription, books)
    const calculateTotal = useCallback(() => {
        return students.reduce((total, student) => {
            let studentTotal = 0;

            // Sum up tuition payments
            (student.concepts_to_pay.tuition || []).forEach(payment => {
                studentTotal += Number(payment.amount) || 0;
            });

            // Add inscription fee if applicable
            if (student.concepts_to_pay.inscription?.amount) {
                studentTotal += Number(student.concepts_to_pay.inscription?.amount) || 0;
            }

            // Add book prices if selected
            (student.concepts_to_pay.books || []).forEach(book => {
                studentTotal += Number(book.price) || 0;

            });

            return total + studentTotal;
        }, 0);
    }, [students, levelList]);

    // Memoized total amount to optimize re-renders
    const totalAmount = useMemo(() => calculateTotal(), [calculateTotal]);

    // Function to add a new student section to the receipt
    const addStudent = () => {
        setStudents(prev => [
            ...prev,
            {
                id_student_section: Date.now(),
                id_student: "",
                name: "",
                concepts_to_pay: {
                    tuition: [],
                    books: [],
                    inscription: {}
                },
                id_class: '',
                inscription_date: '',
                paymentHistory: [],
                schoolarship: {}


            }
        ]);
    };

    // Function to remove a student section from the receipt
    const removeStudentSection = (index) => {
        setStudents(prev => prev.filter((_, i) => i !== index));
    };

    const normalizeOldShape = (ranges) =>
        ranges.map(r => ({
            start: r.range_week_number.start,
            end: r.range_week_number.end
        }));
    const handleConfirm = () => {
        if (students.length === 0) return;

        const isAlreadyInscriptionPayed = students.some(student =>
            student.paymentHistory?.some(payment =>
                payment.concept.split(',').map(item => item.trim()).includes("Inscripcion")
            )
        );

        let canOpenModal = false;

        if (isAlreadyInscriptionPayed) {
            canOpenModal = students.every(student =>
                student.paymentHistory?.some(payment =>
                    payment.concept.split(',').map(item => item.trim()).includes("Inscripcion")
                ) ||
                (student.concepts_to_pay?.inscription && Object.keys(student.concepts_to_pay.inscription).length > 0)
            );
        } else {
            canOpenModal = students.every(student =>
                student.concepts_to_pay?.inscription &&
                Object.keys(student.concepts_to_pay.inscription).length > 0
            );
        }

        if (!canOpenModal) {
            showAlert('info', 'Es necesario pagar la inscripción para al menos un estudiante.')
            return;
        }

        // validaciones para confirmar si se agrego o no tuition a los cocneptos
        const isPayingWeeks = students.every(student =>
            Array.isArray(student.concepts_to_pay?.tuition) &&
            student.concepts_to_pay.tuition.length > 0 &&
            student.concepts_to_pay.tuition.every(t =>
                Array.isArray(t.date) && t.date.length > 0
            )
        );
        const hasTuitionConcept = students.every(student =>
            student.concepts_to_pay?.tuition?.length > 0
        );
        // 🎯 Lógica combinada:
        if (hasTuitionConcept && !isPayingWeeks) {
            showAlert('info', 'Seleccionaste pagar colegiatura y/o abono pero no elegiste semanas. Por favor selecciónalas o elimina el concepto.');
            return;
        }


        if (!hasTuitionConcept && !isPayingWeeks) {
            // No hay colegiaturas ni semanas seleccionadas → solo quiere pagar inscripción/libros
            setIsOpenConfirm(true);
            return;
        }

        // 🎯 Validar que no se repitan semanas entre conceptos de un mismo alumno
        const hasDuplicatedWeeks = students.every(student => {
            const allWeeks = [];

            student.concepts_to_pay?.tuition?.forEach(t => {
                t.date?.forEach(({ week, year }) => {
                    const key = `${year}-${week}`;
                    allWeeks.push(key);
                });
            });

            const uniqueWeeks = new Set(allWeeks);
            return uniqueWeeks.size !== allWeeks.length; // Hay duplicados
        });

        if (hasDuplicatedWeeks) {
            showAlert('danger', 'No puedes seleccionar la misma semana en más de un concepto. Verifica los rangos de semanas en colegiaturas y abonos.');
            return;
        }


        for (const student of students) {
            const { paymentHistory, concepts_to_pay } = student;
            const tuitionPayments = paymentHistory.filter(p => p.concept.includes("Colegiatura"));
            const abonoPayments = paymentHistory.filter(p => p.concept.includes("Abono"));


            let allFullyPaidWeeks = [];

            // Agregar semanas de colegiatura pagadas
            tuitionPayments.forEach(payment => {
                payment.payedWeeks.forEach(w => {
                    if (parseInt(w.paid_is_active) === 1) {
                        allFullyPaidWeeks.push(w.week); // formato "semana-año"
                    }
                });
            });

            // Agregar semanas de abonos al 100%
            abonoPayments.forEach((payment, i) => {
                payment.payedWeeks.forEach((w, index) => {
                    const weekKey = w.week;
                    const abonoPercentStr = payment.conceptPercentages?.["Abono"];
                    let abonoPercent = 0;

                    if (Array.isArray(abonoPercentStr)) {
                        abonoPercent = parseFloat(abonoPercentStr[index]?.replace('%', '')) || 0;
                    } else {
                        abonoPercent = parseFloat(abonoPercentStr?.replace('%', '')) || 0;
                    }

                    if (abonoPercent === 100) {
                        allFullyPaidWeeks.push(weekKey);
                    }
                });
            });


            // Construimos Set de semanas especiales (como "semana-año") para fácil comparación
            const specialWeekSet = new Set(
                specialDates.flatMap(event =>
                    event.weeks.map(w => `${w.week}-${w.year}`)
                )
            );
            // Construimos Set de semanas EXENTAS (NO se pagan, NO se validan)
            const exemptWeekSet = new Set(
                exemptWeeks.map(w => `${w.week}-${w.year}`)
            );

            const inactive_ranges = student.inactive_weeks
            const inactiveWeeks = normalizeOldShape(inactive_ranges);

            const paused_ranges = student.paused_weeks
            const pausedWeeks = normalizeOldShape(paused_ranges);

            // Set de semanas ya pagadas (colegiaturas)
            const paidWeeksSet = new Set(
                tuitionPayments.flatMap(p =>
                    p.payedWeeks
                        .filter(w => parseFloat(w.percent_paid) === 100 && parseInt(w.paid_is_active) === 1)
                        .map(w => w.week)
                )
            );

            // Obtenemos la última semana pagada que NO sea especial
            const lastWeekPaid = allFullyPaidWeeks
                .filter(wk => !specialWeekSet.has(wk))
                .map(week => week.split('-').map(Number)) // convertir ["semana","año"] a números
                .sort((a, b) => a[1] - b[1] || a[0] - b[0]) // ordenar por año y semana
                .pop(); // tomar la última semana pagada

            // toma la primera semana pagada
            const firstWeekPaid = allFullyPaidWeeks
                .filter(wk => !specialWeekSet.has(wk)) // ignorar semanas especiales
                .map(week => week.split('-').map(Number))
                .sort((a, b) => a[1] - b[1] || a[0] - b[0])
                .shift();

            // Obtenemos todas las semanas que se quieren pagar ahora (tuitionToPay)
            const tuitionToPay = concepts_to_pay.tuition?.flatMap(t =>
                t.date.map(d => [d.week, d.year, t.isTuition, t.tuition_price, t.amount])
            ) || [];
            tuitionToPay.sort((a, b) => a[1] - b[1] || a[0] - b[0]);

            const firstWeekToPay = tuitionToPay[0];

            // Crear Set con las semanas que se están pagando en este momento
            const weeksToPaySet = new Set(
                tuitionToPay.map(([week, year]) => `${week}-${year}`)
            );

            // Validar que no se esté pagando alguna semana ya pagada

            for (const [week, year, isTuition] of tuitionToPay) {
                const weekKey = `${week}-${year}`;

                if (exemptWeekSet.has(weekKey)) continue;

                if (isWeekInRanges(weekKey, inactiveWeeks)) continue;
                if (isWeekInRanges(weekKey, pausedWeeks)) continue;
                // La semana NO es exenta → ahora sí continuar con las otras validaciones
                if (paidWeeksSet.has(weekKey)) {
                    const range_week = getWeekRange(week, year)
                    showAlert('info', `El estudiante ${student.name} ya pagó la semana ${range_week}. No puede pagarla de nuevo.`);
                    return;
                }

                // Validar si es anterior al primer pago
                if (
                    firstWeekPaid &&
                    (
                        year < firstWeekPaid[1] ||
                        (year === firstWeekPaid[1] && week < firstWeekPaid[0])
                    )
                ) {
                    const range_week_first_paid = getWeekRange(firstWeekPaid[0], firstWeekPaid[1]);
                    const range_week_selected = getWeekRange(week, year);
                    showAlert('info', `No se puede pagar la semana ${range_week_selected} porque es anterior al primer pago registrado (${range_week_first_paid}).`);
                    return;
                }
            }


            // Aquí: validamos solo si la primera semana a pagar NO es especial
            const firstWeekKey = `${firstWeekToPay[0]}-${firstWeekToPay[1]}`;
            const isFirstWeekSpecial = specialWeekSet.has(firstWeekKey);

            if (!isFirstWeekSpecial && lastWeekPaid && firstWeekToPay) {
                const [lastWeek, lastYear] = lastWeekPaid;
                const [nextWeek, nextYear] = firstWeekToPay;

                const intermediateWeeks = [];
                let currentWeek = lastWeek + 1;
                let currentYear = lastYear;

                // Construir las semanas entre última pagada y primera a pagar
                while (currentYear < nextYear || (currentYear === nextYear && currentWeek < nextWeek)) {
                    if (currentWeek > 52) {
                        currentWeek = 1;
                        currentYear++;
                    }
                    intermediateWeeks.push(`${currentWeek}-${currentYear}`);
                    currentWeek++;
                }

                // Validar que todas las semanas intermedias estén cubiertas (pagadas, abonadas o están en este pago)
                const isAllIntermediateWeeksPaid = intermediateWeeks.every(weekKey => {

                    if (specialWeekSet.has(weekKey)) return true;
                    // 👇 SEMANA EXENTA = PERMITIDO SALTARLA
                    if (exemptWeekSet.has(weekKey)) return true;
                    if (isWeekInRanges(weekKey, inactiveWeeks)) return true;
                    if (isWeekInRanges(weekKey, pausedWeeks)) return true;
                    const isBeingPaidNow = weeksToPaySet.has(weekKey);
                    const alreadyPaidInTuition = paidWeeksSet.has(weekKey);

                    const alreadyPaidInAbono = abonoPayments.some(payment =>
                        payment.payedWeeks.some((w, i) => {
                            if (w.week !== weekKey) return false;

                            const abonoPercentStr = payment.conceptPercentages?.["Abono"];
                            let abonoPercent = 0;

                            if (Array.isArray(abonoPercentStr)) {
                                abonoPercent = parseFloat(abonoPercentStr[i]?.replace('%', '')) || 0;
                            } else {
                                abonoPercent = parseFloat(abonoPercentStr?.replace('%', '')) || 0;
                            }

                            return abonoPercent === 100;
                        })
                    );

                    return isBeingPaidNow || alreadyPaidInTuition || alreadyPaidInAbono;
                });

                if (!isAllIntermediateWeeksPaid) {
                    const cleanedArray = firstWeekToPay.filter(v => v !== true);
                    const firstTwo = cleanedArray.slice(0, 2);
                    const range_week_last_paid = getWeekRange(lastWeekPaid[0], lastWeekPaid[1])
                    const range_week_selected = getWeekRange(firstTwo[0], firstTwo[1])
                    showAlert('info', `El estudiante ${student.name} no puede saltarse semanas sin haberlas pagado. Última pagada: ${range_week_last_paid}, intentando pagar: ${range_week_selected}`);
                    return;
                }
            }




            for (const abono of abonoPayments) {
                for (const weekData of abono.payedWeeks) {
                    const { week, percent_paid, paid_is_active } = weekData;
                    // ⛔ Si la semana NO está activa, no se valida
                    if (parseInt(paid_is_active) !== 1) continue;
                    const percentPaidNum = parseFloat(percent_paid) || 0;
                    if (percentPaidNum < 100) {
                        if (specialWeekSet.has(week)) continue;
                        if (tuitionToPay.some(([w, y, isTuition]) => `${w}-${y}` === week && isTuition === false)) {
                            continue;
                        }
                        const str = week;
                        const [weekS, yearS] = str.split('-');
                        const range_week = getWeekRange(weekS, yearS)
                        showAlert('info', `El estudiante ${student.name} tiene un abono pendiente en la semana ${range_week}, debe completarlo.`)
                        return;
                    }
                }
            }

            for (const [isTuition, tuition_price, amount] of tuitionToPay) {

                if (!isTuition) {
                    if (amount > tuition_price) {
                        showAlert('info', 'El abono que esta realizando supera la cantidad que debe pagar')
                        return
                    }

                }
            }

            // 🚫 Validación: No permitir pagar abonos ya cubiertos al 100%
            for (const [week, year, isTuition] of tuitionToPay) {
                const weekKey = `${week}-${year}`;

                if (!isTuition) {
                    const alreadyPaidAbono = abonoPayments.some(payment =>
                        payment.payedWeeks.some((w, i) => {
                            if (w.week !== weekKey) return false;

                            const abonoPercentStr = payment.conceptPercentages?.["Abono"];
                            let abonoPercent = 0;

                            if (Array.isArray(abonoPercentStr)) {
                                abonoPercent = parseFloat(abonoPercentStr[i]?.replace('%', '')) || 0;
                            } else {
                                abonoPercent = parseFloat(abonoPercentStr?.replace('%', '')) || 0;
                            }

                            return abonoPercent === 100;
                        })
                    );

                    if (alreadyPaidAbono) {
                        const range_week = getWeekRange(week, year)
                        showAlert('info', `El estudiante ${student.name} ya pagó el abono completo de la semana ${range_week}. No puede volver a pagarlo.`)
                        return;
                    }
                }
            }

            for (const [week, year, isTuition] of tuitionToPay) {
                const weekKey = `${week}-${year}`;

                if (isTuition) {
                    const abonoMatch = abonoPayments.find(p =>
                        p.payedWeeks.some(w => w.week === weekKey)
                    );

                    if (abonoMatch) {
                        const weekInfo = abonoMatch.payedWeeks.find(w => w.week === weekKey);

                        const percentPaid = parseFloat(weekInfo?.percent_paid || "0");
                        const paid_is_Active = parseInt(weekInfo?.paid_is_active || "0")
                        const range_week = getWeekRange(week, year)
                        if (paid_is_Active === 1) {
                            if (percentPaid < 100) {
                                showAlert('info', `El estudiante ${student.name} tiene un abono incompleto en la semana ${range_week}. Debe completarlo antes de pagar la colegiatura.`)
                                return;
                            } else {
                                showAlert('info', `El estudiante ${student.name} ya completó el abono de la semana ${range_week}. La colegiatura ya está cubierta.`)
                                return; // 👈 Evita detener el flujo, sigue con la siguiente semana
                            }
                        }
                    }
                }
            }

        }

        // 🚫 Validación: Abonos solo pueden ser a lo mucho una semana después de la última colegiatura seleccionada
        for (const student of students) {
            const { concepts_to_pay, name } = student;
            const tuitions = concepts_to_pay.tuition || [];

            const abonos = tuitions.filter(t => t.isTuition === false);
            const colegiaturas = tuitions.filter(t => t.isTuition === true);
            // Construimos Set de semanas especiales (como "semana-año") para fácil comparación
            const specialWeekSet = new Set(
                specialDates.flatMap(event =>
                    event.weeks.map(w => `${w.week}-${w.year}`)
                )
            );
            if (abonos.length === 0 || colegiaturas.length === 0) continue;

            const lastTuition = colegiaturas
                .flatMap(t => t.date.map(d => ({ week: d.week, year: d.year })))
                .sort((a, b) => a.year - b.year || a.week - b.week)
                .pop();

            for (const abono of abonos) {
                for (const { week, year } of abono.date) {
                    if (specialWeekSet.has(`${week}-${year}`)) continue;
                    const diffWeeks = (year - lastTuition.year) * 52 + (week - lastTuition.week);
                    if (diffWeeks > 1) {
                        showAlert('info', `El estudiante ${name} solo puede pagar un abono hasta una semana después de la última colegiatura seleccionada (${lastTuition.week}-${lastTuition.year}). Verifica el abono a la semana ${week}-${year}.`);
                        return;
                    }
                }
            }
        }

        setIsOpenConfirm(true);
    };



    const handleConfirmClose = () => {
        // Lógica de registro, luego abrir el modal de éxito
        setIsOpenConfirm(false);
    };

    const handleCleanFields = () => {
        handleSubsidiarySelected('')
        setStudentsList([])
    }

    const isPrime = (num) => {
        if (num < 2) return false;
        for (let i = 2; i <= Math.sqrt(num); i++) {
            if (num % i === 0) return false;
        }
        return true;
    };

    const nextPrime = (start) => {
        let n = start;
        while (!isPrime(n)) {
            n++;
        }
        return n;
    };

    const applyPromoCode = async () => {
        setLastPromoCode(promoCode);

        const allStudentsSelected = students.length > 0 &&
            students.every(student =>
                student.id_student !== '' &&
                student.id_student !== null &&
                student.id_student !== undefined
            );

        if (!allStudentsSelected) {
            showAlert('info', 'Debes seleccionar todos los estudiantes antes de aplicar el código promocional.');
            return;
        }

        if (promoCode === lastPromoCode) {
            showAlert('info', 'Recientemente aplicó este código.');
            return;
        }

        const classIds = [...new Set(students.map(student => student.id_class))];

        const form = {
            code: promoCode,
            teacherClasses: classIds
        };

        try {
            const studentPromo = await PostPromotionCodeClass(form);
            if (studentPromo.status === 200) {
                const promotions = studentPromo.promotions;
                let twoForOneIndex = 1;

                const updatedStudents = students.map(student => {
                    const hasPaidInscription = student.paymentHistory.some(history =>
                        history.concept?.toLowerCase().includes('inscripcion')
                    );

                    const matchingPromos = promotions.filter(
                        promo => promo.fk_teacher_class === student.id_class
                    );

                    const enrichedPromos = matchingPromos.map(promo => {
                        const paymentConcept = promo.payment_concept?.toLowerCase();
                        const tuition = student.concepts_to_pay.tuition?.[0];
                        const inscription = student.concepts_to_pay.inscription;

                        // === CASE 1: Tipo FREE ===
                        if (promo.type === 'free') {
                            if (paymentConcept.includes('inscripcion') && inscription) {
                                return {
                                    ...promo, applied: true, updatedConcepts: {
                                        ...student.concepts_to_pay,
                                        inscription: { ...inscription, amount: 0 }
                                    }
                                };
                            }

                            if (paymentConcept.includes('colegiatura') && tuition) {
                                const updatedTuition = student.concepts_to_pay.tuition.map(t => ({
                                    ...t,
                                    amount: 0,
                                    date: t.date.map(d => ({ ...d, tuition_payed: 0 }))
                                }));

                                return {
                                    ...promo, applied: true, updatedConcepts: {
                                        ...student.concepts_to_pay,
                                        tuition: updatedTuition
                                    }
                                };
                            }
                        }

                        // === CASE 2: Tipo PERCENTAGE ===
                        if (promo.type === 'percentage') {
                            const discount = parseFloat(promo.value) / 100;

                            if (paymentConcept.includes('inscripcion') && inscription) {
                                const newAmount = inscription.amount - (inscription.amount * discount);
                                return {
                                    ...promo, applied: true, updatedConcepts: {
                                        ...student.concepts_to_pay,
                                        inscription: { ...inscription, amount: newAmount }
                                    }
                                };
                            }

                            if (paymentConcept.includes('colegiatura') && tuition) {
                                const updatedTuition = student.concepts_to_pay.tuition.map(t => ({
                                    ...t,
                                    amount: t.amount - (t.amount * discount),
                                    date: t.date.map(d => ({
                                        ...d,
                                        tuition_payed: d.tuition_payed - (d.tuition_payed * discount)
                                    }))
                                }));

                                return {
                                    ...promo, applied: true, updatedConcepts: {
                                        ...student.concepts_to_pay,
                                        tuition: updatedTuition
                                    }
                                };
                            }
                        }

                        // === CASE 3: Tipo 2x1 ===
                        if (promo.type === '2x1') {
                            if (hasPaidInscription) {
                                const primeIndex = nextPrime(twoForOneIndex);
                                twoForOneIndex = primeIndex + 1;
                                return { ...promo, index: primeIndex };
                            } else {
                                return { ...promo, index: twoForOneIndex++ };
                            }
                        }
                        // === CASE 4: Tipo QTY ===
                        if (promo.type === 'qty') {
                            const promoValue = parseFloat(promo.value); // Ej. 1600 o 1400
                            const hasInscription = inscription?.amount > 0;
                            const tuitionWeeks = tuition?.date?.length || 0;

                            // Determinar si es "Buen Fin Online" por el nombre
                            const isOnlinePromo = promo.name?.toLowerCase().includes('online');
                            const requiredWeeks = isOnlinePromo ? 4 : 3;

                            // Requisitos: inscripción + n semanas
                            if (hasInscription && tuitionWeeks >= requiredWeeks) {
                                let remainingValue = promoValue;

                                // --- Paso 1: aplicar a inscripción ---
                                const newInscriptionAmount = Math.max(0, inscription.amount - remainingValue);
                                remainingValue = Math.max(0, remainingValue - inscription.amount);

                                // --- Paso 2: aplicar a colegiatura ---
                                const tuition = student.concepts_to_pay.tuition?.[0];
                                const totalTuitionAmount = tuition.amount || 0;

                                const newTuitionAmount = Math.max(0, totalTuitionAmount - remainingValue);
                                const tuitionReduction = totalTuitionAmount - newTuitionAmount;

                                // Distribuir proporcionalmente entre las semanas
                                const updatedTuition = student.concepts_to_pay.tuition.map(t => ({
                                    ...t,
                                    amount: newTuitionAmount,
                                    date: t.date.map(d => {
                                        const weekShare = totalTuitionAmount > 0
                                            ? d.tuition_payed * (1 - tuitionReduction / totalTuitionAmount)
                                            : d.tuition_payed;
                                        return { ...d, tuition_payed: parseFloat(weekShare.toFixed(2)) };
                                    })
                                }));

                                const updatedInscription = {
                                    ...inscription,
                                    amount: newInscriptionAmount
                                };

                                return {
                                    ...promo,
                                    applied: true,
                                    updatedConcepts: {
                                        ...student.concepts_to_pay,
                                        tuition: updatedTuition,
                                        inscription: updatedInscription
                                    }
                                };
                            }
                        }

                        return promo; // por defecto sin cambios
                    });

                    // Si alguna promo modificó los conceptos, usamos la versión modificada
                    const appliedPromo = enrichedPromos.find(p => p.applied && p.updatedConcepts);
                    const updatedConcepts = appliedPromo
                        ? appliedPromo.updatedConcepts
                        : student.concepts_to_pay;

                    return {
                        ...student,
                        concepts_to_pay: updatedConcepts,
                        promotions: enrichedPromos.length > 0 ? enrichedPromos : []
                    };
                });
                setStudents(updatedStudents);
                showAlert('success', 'Código promocional aplicado correctamente.');
            } else {
                showAlert('danger', studentPromo.message);
            }
        } catch (error) {
            console.error('Error al aplicar la promoción:', error);
            showAlert('danger', 'Error al aplicar la promoción.');
        }
    };


    // Función auxiliar para mostrar alertas
    const showAlert = (type, message) => {
        const id = Math.floor(Math.random() * 100) + 1;
        const alertObj = { id, type, message };

        setArrayAlerts(oldArray => [alertObj, ...oldArray]);
        setIsVisibleAlert(true);
    };

    const getAvailableStudents = (currentStudentId) => {
        return studentsList.filter(student => {
            if (
                selectedStudentIds.includes(student.id) &&
                student.id !== currentStudentId
            ) {
                return false;
            }
            return true;
        });
    };
    return (
        <div className="payment-receipt-container">
            <h1 className="title-1">Recibo de pago</h1>
            <div className="payment-student-info">
                <div className="receip-contain sub-color2">
                    <div className="payment-header-buttons transparent-buttons">
                        <Select
                            options={subsidiaryList}
                            placeholder={'Selecciona sucursal...'}
                            classN={'sub-color2 subsidiary'}
                            value={selectedSubsidiary}
                            onChange={(e) => handleSubsidiarySelected(e.target.value)}
                        />
                        <div className="header-buttons">
                            <Tooltip text={'Borrar todos los datos previamente ingresados'}>
                                <Button text={'Limpiar campos'} backgroundColor="transparent" Icon={CleanSVG} onClick={handleCleanFields} />
                            </Tooltip>
                        </div>
                        <h1 className="title-2">Tipo de cambio: {exchange}</h1>
                    </div>
                    {/* Students section */}
                    {loading ? (
                        <p>Cargando alumnos...</p>
                    ) : (
                        students.map((student, index) => (
                            <StudentSection
                                key={student.id_student_section}
                                student={student}
                                setStudents={setStudents}
                                index={index}
                                books={levelList}
                                studentsList={getAvailableStudents(student.id_student)} // 👈 aquí
                                removeStudentSection={removeStudentSection}
                                amountInscription={amountInscription}
                                showAlert={showAlert}
                                exemptWeeks={exemptWeeks}
                                usr={usr}
                                exchange={exchange}
                                levelUnitList={levelUnitList}
                                paymentStudentData={paymentStudentData}
                                setPaymentStudentData = {setPaymentStudentData}

                            />
                        ))
                    )}

                    <div className="transparent-buttons">
                        <Tooltip text={'Agrega alumno adicional si desean realizar su pago en conjunto'}>
                            <Button text={'+ Alumno'} backgroundColor="transparent" onClick={addStudent} />
                        </Tooltip>
                    </div>

                    {/* Payment details section */}
                    <div className="buttons-section">
                        <div className="promotion-code">
                            <InputAnimated
                                type="text"
                                placeholder={"Codigo Promocional"}
                                value={promoCode}
                                onChange={(e) => setPromoCode(e.target.value)}
                            />
                            <Button disabled={!promoCode && true} text={'Aplicar'} backgroundColor="transparent" onClick={applyPromoCode} />
                        </div>
                        <div className="payment-info">
                            <h1 className="title-2">Importe total:</h1>
                            <h1 className="title-2 total-amount">${totalAmount}</h1>

                        </div>

                        {/* Print and send buttons */}
                        <div className="print-buttons">
                            <Button disabled={disableConfirmButton} backgroundColor="blue" text='Continuar a método de pago' onClick={handleConfirm} />
                        </div>
                    </div>
                </div>
            </div>
            {isOpenConfirm &&
                <PaymentConfirm
                    isOpen={isOpenConfirm}
                    onClose={handleConfirmClose}
                    concepts={students}
                    usr={usr}
                    exchange={exchange}
                    setArrayAlerts={setArrayAlerts}
                    setIsVisibleAlert={setIsVisibleAlert}
                    cleanFields={handleCleanFields}
                >

                </PaymentConfirm>}

            <SelectSubsidiary
                isOpen={openModalSubsidiaryReceipts}
                onClose={handleCloseModalToReceiptsSubsidiarySelect}
                job_position="reception"
            />
            <div className="divAlert">
                <Alert arrayAlertsModule={arrayAlerts} setArrayAlertsModule={setArrayAlerts} isVisibleModule={isVisibleAlert} setIsVisibleModule={setIsVisibleAlert} />
            </div>
        </div>
    );
};

export default PaymentReceipt;
